<template>
	<SOSlotModal
		:modal-title="'Hapus Konsumen'"
		:modal-id="id"
		@close="close"
	>
		<template v-slot:modal-body>
			<div class="f-regular f-16 f-c-black m-d-12">
				Konsumen <b>{{ customer.nama_customer }}</b> memiliki:
			</div>
			<div class="f-regular f-16 f-c-black m-d-12">
				• <b>{{ formatRupiah(customer.jumlah_paket_deposit) }}</b> Paket Deposit Aktif <br>
				• Saldo E-Payment <b>{{ customer.jumlah_emoney | currency }}</b>
			</div>
			<div class="f-regular f-16 f-c-black">
				Data tersebut akan hangus dan mengurangi nilai piutang. Yakin ingin hapus konsumen ini?
			</div>
		</template>
		<template v-slot:modal-footer>
			<SOButton
				:text="'Ya, Hapus'"
				:outline="true"
				:full="true"
				@action="deleteCustomer"
			/>
		</template>
	</SOSlotModal>
</template>

<script>
import SOButton from "@/so-components/global/ui/SOButton";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";

export default {
	name: "CustomerModalHapus",
	props: ["customer"],
	components: {
		SOSlotModal,
		SOButton
	},
	data() {
		return {
			id: "modal-customer"
		}
	},
	mounted() {
		$("#" + this.id).modal("show");
	},
	methods: {
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		async deleteCustomer() {
			const res = await this.$store.dispatch("customerModule/deleteCustomer", this.customer.idcustomer)
			if (res.success) {
				this.close()
				this.$toast.success(res.msg)

				await this.$store.commit("customerModule/resetPagination")
				await this.$store.commit("customerModule/resetCustomer")
				await this.$store.commit("customerModule/resetDetailCustomer")
				this.$router.push("/konsumen")
			} else {
				this.$toast.error(res.err)
			}
			this.smartTrackingClick("delete_konsumen_reguler");

		},
	}
}
</script>